module.exports = __webpack_public_path__ + "static/media/RAB2W0.543d2f82.jpg";